import { useEffect, useState } from "react";
import { FetchStatus } from "../types";
export var useIsLoading = function (fetchStatus) {
    var _a = useState(true), neverFetched = _a[0], setNeverFetched = _a[1];
    useEffect(function () {
        if (fetchStatus && fetchStatus !== FetchStatus.Pending) {
            setNeverFetched(false);
        }
    }, [fetchStatus]);
    return neverFetched ? true : fetchStatus === FetchStatus.Pending;
};
//# sourceMappingURL=use-is-loading.js.map